import React, { useMemo } from 'react';
import { Config } from '@leverege/plugin';
import { Content, Dialog, Pane } from '@leverege/ui-elements';
import Constants from '../Constants';
import DeviceSearch from '../../pairing/DeviceSearch';
import S from './SalesFlowLocatorSearch.css';
import { jsx as _jsx } from "react/jsx-runtime";
function SalesFlowLocatorSearch(props) {
  const {
    onClose,
    show,
    onChange,
    actions,
    locatorBlueprint
  } = props;
  const locatorOfflineWindow = Config.get('Pairing', 'locatorOfflineWindow', 1000 * 60 * 60 * 3);
  const DISABLED_CONDITIONS = useMemo(() => {
    return ['or', [{
      attribute: ['locator.batteryLevel', 'locator'],
      condition: '<',
      value: 70,
      message: 'Locator battery below 70%',
      disable: false
    }, {
      attribute: ['locator.keystreamDeviceState', 'locator'],
      condition: '!=',
      value: Constants.KEYSTREAM_ACTIVATED,
      message: 'Locator unactivated',
      checkNull: true,
      disable: false
    }, {
      attribute: ['locator.lastHeartbeat', 'locator'],
      condition: '<',
      value: Date.now() - locatorOfflineWindow,
      message: 'Locator Offline',
      disable: false
    }]];
  }, [locatorOfflineWindow]);
  const nOnChange = evt => {
    onChange(evt);
    onClose();
  };
  return /*#__PURE__*/_jsx(Dialog, {
    animation: "fade",
    onClose: onClose,
    show: show,
    position: "center",
    children: /*#__PURE__*/_jsx(Pane, {
      className: S.container,
      children: /*#__PURE__*/_jsx(Content, {
        children: /*#__PURE__*/_jsx(DeviceSearch, {
          ...props,
          actions: actions.parent(),
          onChange: nOnChange,
          onClick: onClose,
          networkId: locatorBlueprint?.getTagsStartingWith('network:', true)[0],
          disabledConditions: DISABLED_CONDITIONS,
          titleVariant: "dialogTitle",
          titleIcon: "https://recovr-ui-assets.storage.googleapis.com/pair_title_icon.png"
        })
      })
    })
  });
}
export default SalesFlowLocatorSearch;